import { render, staticRenderFns } from "./UploadDetails.vue?vue&type=template&id=4e217e0c&scoped=true&"
import script from "./UploadDetails.vue?vue&type=script&lang=js&"
export * from "./UploadDetails.vue?vue&type=script&lang=js&"
import style0 from "./UploadDetails.vue?vue&type=style&index=0&id=4e217e0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e217e0c",
  null
  
)

export default component.exports